import { fetchUtils } from 'ra-core';

if (!import.meta.env.VITE_API_URL && import.meta.env.PROD) {
    throw new Error('VITE_API_URL environment variable is required in production builds');
}

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5552';

export const httpClient = (url: string, options: any = {}) => {
    // Ensure headers is a Headers object
    if (!options.headers) {
        options.headers = new Headers();
    } else if (!(options.headers instanceof Headers)) {
        // Convert plain object to Headers
        const headersObj = options.headers;
        options.headers = new Headers();
        Object.entries(headersObj).forEach(([key, value]) => {
            options.headers.set(key, value as string);
        });
    }
    
    // Set default headers
    if (!options.headers.has('Accept')) {
        options.headers.set('Accept', 'application/json');
    }
    
    // Set auth headers
    const token = localStorage.getItem('token');
    const tenantUuid = localStorage.getItem('tenantUuid');
    
    if (tenantUuid) {
        options.headers.set('x-tenant-uuid', tenantUuid);
    }
    if (token) {
        options.headers.set('x-tenant-user-auth', token);
    }
    
    // Set Content-Type for POST/PUT/PATCH if body is a string
    if (options.body && typeof options.body === 'string' && !options.headers.has('Content-Type')) {
        options.headers.set('Content-Type', 'application/json');
    }
    
    return fetchUtils.fetchJson(url, options);
}; 